"use client";

import { useJobAtsLink } from "@/features/ats-sync/hooks/use-job-ats-link";
import { Icon } from "@/components/ui/icon";
import { noteSync } from "../lib/gating";

/**
 * Inline composer hint shown when the linked ATS can't receive notes (spec §6).
 * No-op when the job is unlinked or notes sync natively.
 */
export function NoteSyncHint({ jobId }: { jobId: string | null }) {
  const { isLinked, capabilitiesSnapshot, connectorName } = useJobAtsLink(jobId);
  if (!isLinked) return null;

  const decision = noteSync(capabilitiesSnapshot, connectorName);
  if (decision.allowed) return null;

  return (
    <span className="inline-flex items-center gap-1 text-xs text-contrast/50 leading-4">
      <Icon name="IconCircleInfo" size={12} />
      {decision.reason}
    </span>
  );
}
